import { useEffect, useState } from 'react';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { CircularProgress } from '@mui/material';
import { GRID_CHECKBOX_SELECTION_COL_DEF, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { useAppSelector } from '@reduxStore';

enum CellState {
	Default,
	Loading
}

/**
 * Handles the render of the Checkbox cell on the Dispatch Data Grid.
 * Watches the Redux Store Dispatch Board State
 */
export default function RowSelectCheckbox(props: GridRenderCellParams<DispatchLeg>) {
	const [cellState, setCellState] = useState(CellState.Default);
	const { legId } = props.row;
	const { loadingSet } = useAppSelector((state) => state.dispatchBoardState);

	/**
	 * Check the Redux store when one of it's collections change to see if this row's
	 * leg id is included in an event group
	 */
	useEffect(() => {
		if (loadingSet.includes(legId)) {
			setCellState(CellState.Loading);
		} else {
			setCellState(CellState.Default);
		}
	}, [loadingSet, legId]);

	switch (cellState) {
		case CellState.Loading:
			return <CircularProgress size={18} />;
		default:
			/** Otherwise show the regular select check box */
			return GRID_CHECKBOX_SELECTION_COL_DEF.renderCell ? GRID_CHECKBOX_SELECTION_COL_DEF.renderCell(props) : <></>;
	}
}
